export default __webpack_public_path__ + "static/media/mailchimp-icon.dd5b30ab.png";